/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EmergencyAnalytics
 */
export interface EmergencyAnalytics {
    /**
     * 
     * @type {string}
     * @memberof EmergencyAnalytics
     */
    org_code: string;
    /**
     * 
     * @type {number}
     * @memberof EmergencyAnalytics
     */
    count: number;
}

/**
 * Check if a given object implements the EmergencyAnalytics interface.
 */
export function instanceOfEmergencyAnalytics(value: object): value is EmergencyAnalytics {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function EmergencyAnalyticsFromJSON(json: any): EmergencyAnalytics {
    return EmergencyAnalyticsFromJSONTyped(json, false);
}

export function EmergencyAnalyticsFromJSONTyped(json: any, ignoreDiscriminator: boolean): EmergencyAnalytics {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['orgCode'],
        'count': json['count'],
    };
}

export function EmergencyAnalyticsToJSON(json: any): EmergencyAnalytics {
    return EmergencyAnalyticsToJSONTyped(json, false);
}

export function EmergencyAnalyticsToJSONTyped(value?: EmergencyAnalytics | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'orgCode': value['org_code'],
        'count': value['count'],
    };
}

